'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
/** @constructor */
function $c_s_jdk_javaapi_CollectionConverters$() {
}
export { $c_s_jdk_javaapi_CollectionConverters$ as $c_s_jdk_javaapi_CollectionConverters$ };
$p = $c_s_jdk_javaapi_CollectionConverters$.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_s_jdk_javaapi_CollectionConverters$;
/** @constructor */
function $h_s_jdk_javaapi_CollectionConverters$() {
}
export { $h_s_jdk_javaapi_CollectionConverters$ as $h_s_jdk_javaapi_CollectionConverters$ };
$h_s_jdk_javaapi_CollectionConverters$.prototype = $p;
var $d_s_jdk_javaapi_CollectionConverters$ = new $j_java$002elang$002e$002dObject.$TypeData().i($c_s_jdk_javaapi_CollectionConverters$, "scala.jdk.javaapi.CollectionConverters$", ({
  uK: 1,
  sJ: 1,
  sM: 1
}));
export { $d_s_jdk_javaapi_CollectionConverters$ as $d_s_jdk_javaapi_CollectionConverters$ };
var $n_s_jdk_javaapi_CollectionConverters$;
function $m_s_jdk_javaapi_CollectionConverters$() {
  if ((!$n_s_jdk_javaapi_CollectionConverters$)) {
    $n_s_jdk_javaapi_CollectionConverters$ = new $c_s_jdk_javaapi_CollectionConverters$();
  }
  return $n_s_jdk_javaapi_CollectionConverters$;
}
export { $m_s_jdk_javaapi_CollectionConverters$ as $m_s_jdk_javaapi_CollectionConverters$ };
